<div fxFlex="100" fxLayout="column" fxLayoutAlign="stretch">
  <mat-form-field class="hint" [appearance]="labels.appearance || 'outline'" fxFlex>
    <mat-label>{{ labels.title }}</mat-label>
    <input
      matTooltip="{{ returnColumnTooltip() }}"
      matInput
      [placeholder]="labels.placeholder"
      [matAutocomplete]="auto"
      matAutocompletePosition="below"
      [formControl]="search"
      ngDefaultControl />
    <mat-icon *ngIf="labels.info" [matTooltip]="labels.info" matSuffix>info</mat-icon>
    <mat-spinner *ngIf="isLoading" class="spinner" diameter="25" matSuffix></mat-spinner>
    <mat-autocomplete (optionsScroll)="onScroll()" (optionSelected)="onSelectionChanged($event)" [displayWith]="displayFn" #auto="matAutocomplete">
      <mat-option *ngFor="let value of data$ | async" [value]="value">
        <ng-container *ngIf="value" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{ data: value }"></ng-container>
      </mat-option>
    </mat-autocomplete>
    <mat-hint *ngIf="labels.hint"
      ><small>{{ labels.hint }}</small></mat-hint
    >
  </mat-form-field>
</div>
